import { defineComponent as _defineComponent } from 'vue'
import { resolveComponent as _resolveComponent, createVNode as _createVNode, unref as _unref, createElementVNode as _createElementVNode, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "container-fluid" }
const _hoisted_2 = { class: "row" }

import { ref, defineAsyncComponent } from 'vue'

export default /*@__PURE__*/_defineComponent({
  __name: 'indexMega',
  setup(__props) {

const variationRadio = defineAsyncComponent(() => import("@/components/theme/forms/formcontrol/magaoption/variationRadio.vue"))
const variationCheckbox = defineAsyncComponent(() => import("@/components/theme/forms/formcontrol/magaoption/variationCheckbox.vue"))
const defultStyle = defineAsyncComponent(() => import("@/components/theme/forms/formcontrol/magaoption/defultStyle.vue"))
const borderStyle = defineAsyncComponent(() => import("@/components/theme/forms/formcontrol/magaoption/borderStyle.vue"))
const solidBorder = defineAsyncComponent(() => import("@/components/theme/forms/formcontrol/magaoption/solidBorder.vue"))
const offerBorder = defineAsyncComponent(() => import("@/components/theme/forms/formcontrol/magaoption/offerBorder.vue"))
const inlineStyle = defineAsyncComponent(() => import("@/components/theme/forms/formcontrol/magaoption/inlineStyle.vue"))
const verticalStyle = defineAsyncComponent(() => import("@/components/theme/forms/formcontrol/magaoption/verticalStyle.vue"))
const horizontalStyle = defineAsyncComponent(() => import("@/components/theme/forms/formcontrol/magaoption/horizontalStyle.vue"))

return (_ctx: any,_cache: any) => {
  const _component_Breadcrumbs = _resolveComponent("Breadcrumbs")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createVNode(_component_Breadcrumbs, {
      main: "Form Controls",
      title: "Mega Options"
    }),
    _createElementVNode("div", _hoisted_1, [
      _createElementVNode("div", _hoisted_2, [
        _createVNode(_unref(variationRadio)),
        _createVNode(_unref(variationCheckbox)),
        _createVNode(_unref(defultStyle)),
        _createVNode(_unref(borderStyle)),
        _createVNode(_unref(solidBorder)),
        _createVNode(_unref(offerBorder)),
        _createVNode(_unref(inlineStyle)),
        _createVNode(_unref(verticalStyle)),
        _createVNode(_unref(horizontalStyle))
      ])
    ])
  ], 64))
}
}

})